import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import convoStore from '../convo-store'
import setConvoQuery from './set-convo-query'

export default async function toggleCreatedByFollowing(context: BareActionContext<ConvoState, RootState>)
{
  const form = convoStore.state.convoSearchForm
  form.createdByUser = false
  form.createdByMe = false
  setConvoQuery(context)

  return
}
